import React from "react";

export function ValidationSummaryText() {
  return (
    <div className="validation-summary-errors">
      There were errors with this submission. Please correct the errors below
      and resubmit.
    </div>
  );
}
